<template>
    <transition name="fade">
        <section>
            <div class="modal fade" :id="id" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Home Address</h5>
                        </div>
                         <div class="modal-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Province</label>
                                        <input class="form-control form-control-sm" type="text" disabled v-model='formAddress.province'>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>City/Municipality</label>
                                        <input class="form-control form-control-sm" type="text" disabled v-model="formAddress.city">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Barangay</label>
                                        <input class="form-control form-control-sm" type="text" disabled v-model='formAddress.bname'>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>House No/Block & Lot/Building</label>
                                        <input class="form-control form-control-sm" type="text" disabled v-model='formAddress.bldg'>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Street Name / Subdivision</label>
                                        <input class="form-control form-control-sm" type="text" disabled v-model="formAddress.street_address">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Ownership</label>
                                        <input class="form-control form-control-sm" type="text" disabled v-model='formAddress.owner_desc'>
                                    </div>
                                </div>
                            </div>
                        </div>
                     
                        <div class="modal-footer">
                            <button class="btn btn-default" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    export default {
        props: ['id', 'formAddress'],
        data() {
            return {}
        },
        created() {

        },
        methods: {},
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>